const paddingBasePixels = 10;

export default {
  two: `${paddingBasePixels * 0.2}px`,
  four: `${paddingBasePixels * 0.4}px`,
  five: `${paddingBasePixels * 0.5}px`,
  six: `${paddingBasePixels * 0.6}px`,
  eight: `${paddingBasePixels * 0.8}px`,
  ten: `${paddingBasePixels * 1}px`,
  twelve: `${paddingBasePixels * 1.2}px`,
  fourteen: `${paddingBasePixels * 1.4}px`,
  fifteen: `${paddingBasePixels * 1.5}px`,
  sixteen: `${paddingBasePixels * 1.6}px`,
  eighteen: `${paddingBasePixels * 1.8}px`,
  twenty: `${paddingBasePixels * 2}px`
};
